document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.kv-pdp').forEach(function (root) {
    var mainImg = root.querySelector('[data-kv-gallery-main]');
    var thumbs = root.querySelectorAll('[data-kv-thumb]');
    var swatches = root.querySelectorAll('[data-kv-swatch]');
    var priceEl = root.querySelector('[data-kv-price]');
    var colourLabel = root.querySelector('[data-kv-colour-label]');
    var skuEl = root.querySelector('[data-kv-sku]');
    var variantInput = root.querySelector('[data-kv-variant-input]');
    var variantSection = root.parentElement.querySelector('[id^="kv-variant-galleries-"]');

    function setMainImage(src) {
      if (mainImg && src) mainImg.src = src;
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('on'); });
        thumb.classList.add('on');
        setMainImage(thumb.getAttribute('data-src'));
      });
    });

    swatches.forEach(function (sw) {
      sw.addEventListener('click', function () {
        var variantId = sw.getAttribute('data-variant-id');
        var colour = sw.getAttribute('data-colour');
        var price = sw.getAttribute('data-price');
        var available = sw.getAttribute('data-available') === 'true';

        swatches.forEach(function (s) { s.classList.remove('on'); });
        sw.classList.add('on');

        if (colourLabel) colourLabel.textContent = colour;
        if (priceEl) priceEl.textContent = price;
        if (variantInput) variantInput.value = variantId;

        // swap gallery to this variant's dedicated images if any exist
        if (variantSection) {
          var galleryBlock = variantSection.querySelector('[data-variant-id="' + variantId + '"]');
          var images = galleryBlock ? galleryBlock.querySelectorAll('img') : [];
          if (images.length > 0) {
            setMainImage(images[0].src);
            var thumbWrap = root.querySelector('[data-kv-gallery-thumbs]');
            if (thumbWrap) {
              thumbWrap.innerHTML = '';
              images.forEach(function (img, i) {
                var btn = document.createElement('button');
                btn.type = 'button';
                btn.className = 'kv-thumb' + (i === 0 ? ' on' : '');
                btn.setAttribute('data-kv-thumb', '');
                btn.setAttribute('data-src', img.src);
                var thumbImg = document.createElement('img');
                thumbImg.src = img.src;
                thumbImg.loading = 'lazy';
                btn.appendChild(thumbImg);
                btn.addEventListener('click', function () {
                  thumbWrap.querySelectorAll('.kv-thumb').forEach(function (t) { t.classList.remove('on'); });
                  btn.classList.add('on');
                  setMainImage(img.src);
                });
                thumbWrap.appendChild(btn);
              });
            }
          }
        }

        // update URL for shareability, without reloading
        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variantId);
          history.replaceState({}, '', url);
        }

        // update SKU from the variants JSON blob
        var jsonEl = root.parentElement.querySelector('[data-kv-variant-json]');
        if (jsonEl && skuEl) {
          try {
            var variants = JSON.parse(jsonEl.textContent);
            var match = variants.filter(function (v) { return String(v.id) === String(variantId); })[0];
            if (match) skuEl.textContent = match.sku;
          } catch (e) {}
        }

        // disable add-to-cart if unavailable
        var addBtn = root.querySelector('.kv-trade-actions .kv-btn-solid');
        if (addBtn && addBtn.tagName === 'BUTTON') {
          addBtn.disabled = !available;
          addBtn.textContent = available ? 'Add to order' : 'Out of stock';
        }
      });
    });
  });
});
